module.exports = __webpack_public_path__ + "img/fig04.fa39f0d9.jpg";